module.exports = __webpack_public_path__ + "img/CDruid64_ua.08de7888.webp";